const parseVersion = (version) => version.split('.').map(Number);

export const compareSemverVersions = (version1, version2) => {
  const v1 = parseVersion(version1);
  const v2 = parseVersion(version2);

  const length = Math.max(v1.length, v2.length);

  for (let i = 0; i < length; i++) {
    const segment1 = v1[i] ?? 0;
    const segment2 = v2[i] ?? 0;

    if (segment1 !== segment2) {
      return segment1 < segment2;
    }
  }

  return false;
};
